<template>
  <div id="development_section" class="flex flex-wrap items-center mt-32 pb-32">
    <div class="w-full md:w-5/12 px-4 mr-auto ml-auto">
      <div
        class="p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full"
      >
        <i class="fas fa-desktop text-xl"></i>
      </div>
      
      <h3 class="text-3xl mb-2 font-semibold leading-normal">Wir bieten Ihnen Ihre digitale Lösung</h3>
      <p
        class="text-lg font-light leading-relaxed mt-4 mb-4 text-gray-700"
      >Mit unserem Know-How unterstützen wir Sie bei der detaillierten Ausarbeitung Ihrer Projektidee, 
      definieren mit Ihnen gemeinsam die Anforderungen und setzen für Sie das Projekt technisch um. 
      Selbstverständlich begleiten wir Sie auch nach der Projekteinführung und sichern Ihnen so eine nachhaltige und 
      langfristige Weiterentwicklung Ihrer Software-Projekte.</p>
     <p class="pt-6"><a href="#contactForm" v-smooth-scroll>Starten Sie in die digitale Zukunft und nehmen Sie unverbindlich mit uns Kontakt auf.</a></p>
    </div>
    <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
       <img
          alt="..."
          src="../assets/img/development.jpg"
          srcset="../assets/img/development_small.jpg 480w, ../assets/img/development.jpg 800w"
          sizes="(max-width: 600px) 480px, 800px"
          class="w-full align-middle rounded-lg shadow-lg"
        />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>